'use client';

import Image from '@/components/Image';
import PopupResponsive from '@/components/PopupResponsive';
import { env } from '@/utils/env';
import { useTranslations } from 'next-intl';

interface PresTypeDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function PresTypeDialog({ open, onClose }: PresTypeDialogProps) {
  const t = useTranslations('lens-process');
  const prescriptionTypeImgMap = {
    fr: '/goods-detail/type1-fr.png',
    de: '/goods-detail/type1-de.png',
    default: '/goods-detail/type1.png',
  };
  const singleTypeImgMap = {
    fr: '/goods-detail/single_type-fr.png',
    de: '/goods-detail/single_type-de.png',
    default: '/goods-detail/single_type.png',
  };
  const proImgMap = {
    fr: '/goods-detail/pro-fr.png',
    de: '/goods-detail/pro-de.png',
    default: '/goods-detail/pro.png',
  };
  const { NEXT_PUBLIC_SITE_NAME: siteName } = env;
  return (
    <PopupResponsive
      open={open}
      height={'70%'}
      onClose={onClose}
      title={t('whichOneShouldI')}
      className="prescription-type-dialog"
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '70vh',
        },
      }}
    >
      <div className="space-y-6">
        <p className="text-sm">{t('takeACloseLookAtYourPrescription')}</p>
        <div className="mb-4">
          <Image
            src={prescriptionTypeImgMap[siteName] || prescriptionTypeImgMap.default}
            alt={t('prescriptionType')}
            width={485}
            height={224}
            className="mx-auto"
          />
        </div>
        <div>
          <h3 className="font-bs text-[16px] mb-[12px]">{t('singleVision')}</h3>
          <p className="text-sm mb-4">{t('singleVisionDescription')}</p>
          <Image
            src={singleTypeImgMap[siteName] || singleTypeImgMap.default}
            alt={t('singleVision')}
            width={485}
            height={224}
            className="mx-auto"
          />
        </div>
        <div>
          <h3 className="font-bs text-[16px] mb-[12px]">{t('progressive')}</h3>
          <p className="text-sm mb-4">{t('progressiveDescription')}</p>
          <Image
            src={proImgMap[siteName] || proImgMap.default}
            alt={t('progressive')}
            width={485}
            height={224}
            className="mx-auto"
          />
        </div>
        <div>
          <h3 className="font-bs text-[16px] mb-[12px]">{t('nonPrescription')}</h3>
          <p className="text-sm">{t('nonPrescriptionDescription')}</p>
        </div>
      </div>
    </PopupResponsive>
  );
}
